/**
 * awsConfigCheckItem模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const awsConfigCheckItem = {
    //合规检查下拉框
    queryConfigRuleCheckItems(params) {
        return $http.post(`${global.API_URL}/sme/awsConfigCheckItem/queryConfigRuleCheckItems`, params);
    },
    //概览表格
    queryConfigRuleCheckItemsTable(params) {
        return $http.post(`${global.API_URL}/sme/awsConfigCheckItem/queryConfigRuleCheckItemsTable`, params);
    },
    //详情表格
    queryConfigRuleCheckItemsDetail(params) {
        return $http.post(`${global.API_URL}/sme/awsConfigCheckItem/queryConfigRuleCheckItemsDetail`, params);
    }
}

export default awsConfigCheckItem;



// WEBPACK FOOTER //
// ./src/api/awsConfigCheckItem.js